import { useQuery } from '@tanstack/react-query';
import { getFlightBrief, getSharedFlightBrief } from './flightBriefsService';

/**
 * @description Get one flight brief.
 * @param {string} uuid
 * @param {QueriesOptions} [options] useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<FlightBrief, Error>}
 */
export const useGetFlightBrief = (uuid, options) => useQuery({
  queryKey: ['get-flight-brief', uuid],
  queryFn: () => getFlightBrief(uuid),
  ...options,
});

/**
 * @description Get one flight brief to share.
 * @param {string} uuid
 * @param {QueriesOptions} [options] useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<SharedFlightBrief, Error>}
 */
export const useGetSharedFlightBrief = (uuid, options) => useQuery({
  queryKey: ['get-shared-flight-brief', uuid],
  queryFn: () => getSharedFlightBrief(uuid),
  ...options,
});
